import axios from 'axios';
import { AppConsts } from '../enums/AppConsts';
import { SetPlayerMarketingModel } from '../models/player';
const baseUrl = process.env.BASE_SERVER_ADDRESS;
const getToken = () => localStorage.getItem(AppConsts.AccessToken);
const getHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const SetPlayermarketingPropQuery = async (model: SetPlayerMarketingModel) => {
  return await axios.post(`${baseUrl}/Player/SetMarketingPreferenceClient`, model, getHeaders());
};
